/** MODAL_STATE */
const initialState = {}

export const modalState = (state: any = initialState, action: any) => {
    switch (action.type) {
        case "SET_MODAL_STATE":
            return {
                ...state,
                ...action.payload,
            }

        default:
            return state
    }
}
